import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';


const Footer = () => {
  const classes = useStyles();

	return (
		<div className={classes.root}>
			<Typography variant='subtitle1' gutterBottom>
				2022 Copyright by @DanielP.
			</Typography>
			<Typography variant='subtitle2' gutterBottom>
				.Privacy .Terms .Sitemap
			</Typography>
		</div>
	)
}

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: "1px solid #ccc",
    textAlign: "center",
    fontStyle: "italic",
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    background: "whitesmoke",
  },
  
}));

export default Footer